import React, {useState, useEffect, useContext} from 'react';
import axios from "../common/axios";
import ListItem from "../common/ListItem";
import {UserContext} from "../common/UserContext";
import {BrandContext} from "../common/BrandContext";

const ChildMenu = props => {
    const {shortcut, singlePage, handleClick, callback, menuComponents, handleClose} = props;
    const {user} = useContext(UserContext);
    const brandConfig = useContext(BrandContext);

    return (
        <>
            {shortcut == undefined || shortcut.childShortcuts === undefined || shortcut.childShortcuts.length == 0 && (
                <div>No options</div>
            )}
            {shortcut !== undefined && shortcut.childShortcuts !== undefined && shortcut.childShortcuts.length > 0 && (
                <ul className={'ch-list'}>
                    {shortcut.childShortcuts.map((childShortcut, index) => {
                        if(childShortcut.shortcutId == 112 && user.actForUserId == undefined) {
                            return null;
                        } else if (childShortcut.shortcutId === 158 && user.actForUserId !== undefined) {
                            return null;
                        }

                        let menuComponent = (childShortcut.menuComponent ? childShortcut.menuComponent : undefined);
                        const MenuComponentTag = menuComponents[menuComponent];
                        if (MenuComponentTag !== undefined) {
                            return (
                                <MenuComponentTag key={childShortcut.shortcutId} shortcut={childShortcut} handleClose={handleClose} />
                            )
                        } else {
                            return (
                                <ListItem isDisclosureItem={true} className="ch-nav-sub-item" key={index} onClick={() => {handleClick(childShortcut)}}>
                                    {childShortcut.name}
                                </ListItem>
                            )
                        }
                    })}
                </ul>
            )}
        </>
    )
}

export default ChildMenu;